import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

import { textColors, textSizes, TypographyProps } from "../../config/tailwind";

interface LabelProps
  extends Omit<Headless.LabelProps, "as" | "className" | "color">,
    TypographyProps {}

export const Label = ({
  className,
  color = "default",
  size = "base",
  ...props
}: LabelProps): ReactElement => (
  <Headless.Label
    className={clsx(
      "select-none",
      textSizes[size],
      textColors[color],
      "data-[disabled]:opacity-50",
      className,
    )}
    data-slot="label"
    {...props}
  />
);
